import {
  Component, OnInit, OnDestroy,
} from '@angular/core';
import { BulletinBoardService } from 'src/app/services/bulletin-board.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-post',
  templateUrl: './edit-post.component.html',
  styleUrls: [ './edit-post.component.scss' ],
})
export class EditPostComponent implements OnInit, OnDestroy {
  tinyMceKey = environment.tinyMceKey;
  isLoading = false;
  post: {
    title: '',
    content: '',
    publishedDate: '',
    publishedBy: '',
    id: '',
  };
  postsData$ = this.bulletinBoardService.postsData$;
  postsSubscription = this.postsData$.subscribe((data) => {
    this.isLoading = false;
    if (!data) {
      return;
    }

    this.post = data;
  });

  constructor(
    private bulletinBoardService: BulletinBoardService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.searchForPost();
  }

  searchForPost() {
    this.isLoading = true;
    this.bulletinBoardService.getPost(this?.route?.snapshot?.params['id'])
  }

  formatDate = (date) => {
    const dt = new Date(date)
    const month = dt.getMonth() + 1
    const day = dt.getDate()
    const year = dt.getFullYear().toString().slice(2, 4)
    return month < 10 ? `0${month}/${day}/${year}` : `${month}/${day}/${year}`
  }

  formatTime = (publishedDate) => {
    const date = new Date(publishedDate)
    let hours = date.getHours();
    let minutes = date.getMinutes().toString();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes.padStart(2, '0')
    const time = hours + ':' + minutes + ' ' + ampm;
    return time
  }

  getPostTime = () => {
    return `${this.formatDate(this.post?.publishedDate)}, ${this.formatTime(this.post?.publishedDate)}`
  }

  goBack = () => {
    this.router.navigate([ '/bulletin-board' ])
  }

  updatePost = () => {
    this.postsSubscription = this.bulletinBoardService.updatePost(this.post).subscribe({
      next: (response: any) => {
        this.toastService.setToast({
          text: 'Post successfully updated', type: 'success', icon: true,
        })
        this.router.navigate([ '/bulletin-board/' + this.post.id ])
      },
      error: (error) => {
        console.log('error', error);
        this.toastService.setToast({
          text: 'Oops, something went wrong', type: 'error', icon: true,
        })
      },
    })
  }

  deletePost = () => {
    this.postsSubscription = this.bulletinBoardService.deletePost(this.post).subscribe({
      next: (response: any) => {
        this.toastService.setToast({
          text: 'Post successfully removed', type: 'success', icon: true,
        })
        this.router.navigate([ '/bulletin-board' ])
      },
      error: (error) => {
        console.log('error', error);
        this.toastService.setToast({
          text: 'Oops, something went wrong', type: 'error', icon: true,
        })
      },
    })
  }

  ngOnDestroy() {
    this.postsSubscription.unsubscribe();
  }

}
